import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { ItemsPages } from "../../../api/packbo/models/items-pages";

type PageState = {
    page: ItemsPages | null;
};

const initialState: PageState = {
    page: null
};

export const PageStore = signalStore(
    withState(initialState),
    withMethods((store) => ({
        setPage(page: ItemsPages | null) {
            patchState(store, { page });
        }
    }))
);
